import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey" }
const _hoisted_2 = { class: "groupInputs flex" }
const _hoisted_3 = { class: "inputRow" }
const _hoisted_4 = { class: "inputTitle" }
const _hoisted_5 = { class: "inputField flex-grow" }
const _hoisted_6 = { class: "groupInputs flex" }
const _hoisted_7 = { class: "inputRow" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputField flex-grow" }
const _hoisted_10 = { class: "helpText mt-4" }

import {onMounted, ref, toRef} from "vue";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {ActivityInfo} from "@/models/activity/ActivityInfo";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {useGlobalStore} from "@/stores/GlobalStore";
import Select from "@/components/inputs/Select.vue";
import {ActivityService} from "@/utilities/services/entities/ActivityService";
import isNullOrUndefined from "@/utilities/helpers/NullOrUndefinedHelper";



export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationChangeActivityText',
  props: {
  data: Object
},
  setup(__props) {

const globalStore = useGlobalStore();

const props = __props

const popupData = toRef(props, "data");

const activityService = new ActivityService();

const activityTextInput = ref("");
const activityList = ref<Array<ActivityInfo>|null>(null);
const defaultActivity = ref("");
// just used to reset the dropdown when there is text-filed-input
const dropDownSelectedId = ref(null);

const activitySelected = (id:number)=>{
  // set this just to be able to reset the dropdown when there is text-input
  dropDownSelectedId.value = id;

  // only clear input field and set values if a real activity was selected -> avoid cycling reset of the 2 inputs
  if(!isNullOrUndefined(dropDownSelectedId.value)){
    activityTextInput.value = "";

    const foundActivity = activityList.value?.find(a => a.id === id);
    popupData.value.activityText = foundActivity?.name;
    popupData.value.activityId = foundActivity?.id;
  }
  // if x was pressed set default value
  else if (id === null) {
    popupData.value.activityText = defaultActivity.value;
    popupData.value.activityId = undefined;
  }
}

const setActivityList = async ()=>{
  activityList.value = [];

  activityList.value = await activityService.getActivities("display", ErrorLocationType.popup);
}

const inputChanged = ()=>{
  // reset dropdown only if it has value
  if(!isNullOrUndefined(dropDownSelectedId.value)) dropDownSelectedId.value = null;

  // filter whitespace-only with regex && check for null/undefinded or empty string via helper, if true set back to default-activity
  if(NullOrUndefinedHelper(activityTextInput.value) || activityTextInput.value.match(/^\s+$/g)?.some(()=>true)) {
    popupData.value.activityText = defaultActivity.value;
    popupData.value.activityId = undefined;
  }
  else {
    popupData.value.activityText = activityTextInput.value;
    popupData.value.activityId = undefined;
  }
}

onMounted(async ()=>{
  // save default activity text
  defaultActivity.value = globalStore.modal.contentObject.activityText;
  await setActivityList();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t("popups.registrationReports.changeActivity.currentActivityTitle")), 1),
    _createTextVNode(" " + _toDisplayString(popupData.value.activityText) + " ", 1),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("popups.registrationReports.changeActivity.takeGivenActivity")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Select, {
            searchable: false,
            options: activityList.value,
            onSelectChanged: activitySelected,
            selected: dropDownSelectedId.value
          }, null, 8, ["options", "selected"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("popups.registrationReports.changeActivity.createNewActivity")), 1),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "w-full",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activityTextInput).value = $event)),
            onInput: inputChanged
          }, null, 544), [
            [_vModelText, activityTextInput.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("popups.registrationReports.changeActivity.description")), 1)
  ]))
}
}

})